





import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';

export const AppContext = createContext();

export const useAppContext = () => {
  return useContext(AppContext);
};

const getAccountStatusType = (accountStatus) => {
  if (accountStatus === undefined || accountStatus === null) return "unknown";
  if (typeof accountStatus === "boolean") return accountStatus ? "active" : "inactive";
  if (typeof accountStatus === "number") {
    if (accountStatus === 1) return "active";
    if (accountStatus === 0) return "inactive";
    return "unknown";
  }
  if (typeof accountStatus === "string") {
    const normalized = accountStatus.trim().toLowerCase();
    if (normalized === "true" || normalized === "1" || normalized === "active") return "active";
    if (normalized === "false" || normalized === "0" || normalized === "inactive") return "inactive";
    return "unknown";
  }
  return "unknown";
};

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('userProfile');
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      const status = getAccountStatusType(parsed.accountStatus);
      if (status === "inactive") {
        let localBalance = localStorage.getItem("inactiveWalletBalance");
        if (localBalance === null) {
          localBalance = "1500";
          localStorage.setItem("inactiveWalletBalance", "1500");
        }
        parsed.walletBalance = localBalance;
      }
      return parsed;
    }
    return null;
  });
  
  const [loading, setLoading] = useState(true);
  const [mobileNo, setMobileNo] = useState(() => localStorage.getItem('mobileNo') || '');
  const [userPin, setUserPin] = useState('');
  const [otp, setOtp] = useState('');

  useEffect(() => {
    if (mobileNo) localStorage.setItem('mobileNo', mobileNo);
    else localStorage.removeItem('mobileNo');
  }, [mobileNo]);

  const updateWalletBalance = (newBalance) => {
    setUser(currentUser => {
      if (!currentUser) return null;
      const updatedUser = { ...currentUser, walletBalance: newBalance.toString() };
      
      const accountStatusType = getAccountStatusType(currentUser.accountStatus);
      if (accountStatusType === "inactive") {
        localStorage.setItem('inactiveWalletBalance', newBalance.toString());
      }
      
      localStorage.setItem('userProfile', JSON.stringify(updatedUser));
      localStorage.setItem('walletBalance', newBalance.toString());
      
      return updatedUser;
    });
  };

   const resetUserContext = useCallback(() => {
    console.log("LOGGING OUT: Clearing all user data...");
    setUser(null);
    setMobileNo('');
    setUserPin('');
    setOtp('');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('registerId');
    localStorage.removeItem('walletBalance');
    localStorage.removeItem('mobileNo');
    localStorage.removeItem('feeSettings');
    localStorage.removeItem('inactiveWalletBalance');
    localStorage.removeItem('inactiveTransactions');
    localStorage.removeItem('inactiveBids');
  }, []);

 const fetchUserProfile = useCallback(async () => {
  const token = localStorage.getItem("accessToken");
  const registerId = localStorage.getItem("registerId");

  if (!token || !registerId) {
    setUser(null);
    setLoading(false);
    return;
  }
  
  setLoading(true);
  try {
    const response = await axios.post(
      "https://admin.gama567app.net/api/v1/user-details-by-register-id",
      { registerId },
      { 
        headers: { 
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
          "deviceId": "qwert",
          "deviceName": "sm2233",
          "accessStatus": "1",
        } 
      }
    );

    if (response.data?.status === true) {
      const userInfo = response.data.info;
      const accountStatusType = getAccountStatusType(userInfo.accountStatus);
      if (accountStatusType === "inactive") {
        let localBalance = localStorage.getItem("inactiveWalletBalance");
        if (localBalance === null) {
          localBalance = "1500";
          localStorage.setItem("inactiveWalletBalance", "1500");
        }
        userInfo.walletBalance = localBalance;
      }
      setUser(userInfo);
      localStorage.setItem('userProfile', JSON.stringify(userInfo));
      localStorage.setItem('walletBalance', userInfo.walletBalance);
    } else {
      console.error("Failed to fetch user profile, logging out:", response.data.msg);
      resetUserContext();
    }
  } catch (error) {
    console.error("API Network Error fetching user profile:", error);
  } finally {
    setLoading(false);
  }
}, [resetUserContext]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  const isInactive = user && getAccountStatusType(user.accountStatus) === "inactive";

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
        isInactive,
        loading,
        mobileNo,
        setMobileNo,
        userPin,
        setUserPin,
        otp,
        setOtp,
        resetUserContext,
        updateWalletBalance,
        refetchUser: fetchUserProfile,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};









// import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
// import axios from 'axios';

// export const AppContext = createContext();

// export const useAppContext = () => {
//   return useContext(AppContext);
// };

// export const AppProvider = ({ children }) => {
//   // --- STATE MANAGEMENT ---
//   const [user, setUser] = useState(() => {
//     const storedUser = localStorage.getItem('userProfile');
//     return storedUser ? JSON.parse(storedUser) : null;
//   });
  
//   const [loading, setLoading] = useState(true);
//   const [mobileNo, setMobileNo] = useState(() => localStorage.getItem('mobileNo') || '');
//   const [userPin, setUserPin] = useState('');
//   const [otp, setOtp] = useState('');
//   const [appSettings, setAppSettings] = useState(() => {
//     const storedSettings = localStorage.getItem('appSettings');
//     return storedSettings ? JSON.parse(storedSettings) : null;
//   });

//   useEffect(() => {
//     if (mobileNo) localStorage.setItem('mobileNo', mobileNo);
//     else localStorage.removeItem('mobileNo');
//   }, [mobileNo]);

//   const resetUserContext = useCallback(() => {
//     console.log("LOGGING OUT: Clearing all user data...");
//     setUser(null);
//     setMobileNo('');
//     setUserPin('');
//     setOtp('');
//     localStorage.removeItem('userProfile');
//     localStorage.removeItem('accessToken');
//     localStorage.removeItem('registerId');
//     localStorage.removeItem('walletBalance');
//     localStorage.removeItem('mobileNo');
//     localStorage.removeItem('appSettings');
//     setAppSettings(null);
//   }, []);

//   const fetchUserProfile = useCallback(async () => {
//     const token = localStorage.getItem("accessToken");
//     const registerId = localStorage.getItem("registerId");

//     if (!token || !registerId) {
//       setUser(null);
//       return; // No need to set loading false here, finally block will do it
//     }
    
//     try {
//       const response = await axios.post(
//         "https://admin.gama567app.net/api/v1/user-details-by-register-id",
//         { registerId },
//         { 
//           headers: { 
//             "Authorization": `Bearer ${token}`, "Content-Type": "application/json",
//             "deviceId": "qwert", "deviceName": "sm2233", "accessStatus": "1",
//           } 
//         }
//       );

//       if (response.data?.status === true) {
//         const userInfo = response.data.info;
//         setUser(userInfo);
//         localStorage.setItem('userProfile', JSON.stringify(userInfo));
//         localStorage.setItem('walletBalance', userInfo.walletBalance);
//       } else {
//         console.error("Failed to fetch user profile, logging out:", response.data.msg);
//         resetUserContext();
//       }
//     } catch (error) {
//       console.error("API Network Error fetching user profile:", error);
//     }
//   }, [resetUserContext]);

//   // This useEffect runs once on initial app load to fetch all necessary data
//   useEffect(() => {
//     const initializeApp = async () => {
//       setLoading(true);
      
//       // Fetch user profile if tokens exist
//       await fetchUserProfile();

//       // --- ADDED BACK: Fetch App Settings ---
//       const storedMobileNo = localStorage.getItem("mobileNo");
//       const token = localStorage.getItem("accessToken");
//       if (storedMobileNo) {
//         try {
//            const response = await axios.get(
//             "https://admin.gama567app.net/api/v1/fees-settings",
//             {
//               params: {
//                 mobileNo: storedMobileNo // For GET requests, data is sent in 'params'
//               },
//               headers: {
//                 "Authorization": `Bearer ${token}`,
//                 "Content-Type": "application/json",
//                 "deviceId": "qwert",
//                 "deviceName": "sm2233",
//                 "accessStatus": "1"
//               }
//             }
//           );
//           console.log(response);
//           if (response.data?.status) {
//             const settings = response.data.info;
//             setAppSettings(settings);
//             localStorage.setItem('appSettings', JSON.stringify(settings));
//           }
//         } catch (error) {
//           console.error("Failed to fetch app settings:", error);
//         }
//       }
      
//       setLoading(false);
//     };

//     initializeApp();
//   }, [fetchUserProfile]); // Depends on fetchUserProfile

//   return (
//     <AppContext.Provider
//       value={{
//         user,
//         setUser,
//         loading,
//         mobileNo,
//         setMobileNo,
//         userPin,
//         setUserPin,
//         otp,
//         setOtp,
//         appSettings, // Provide settings
//         resetUserContext,
//         refetchUser: fetchUserProfile, // Provide refetch function
//       }}
//     >
//       {children}
//     </AppContext.Provider>
//   );
// };
